
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[format-converter]",
      function () {
        return require("private-next-pages/[format-converter]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[format-converter]"])
      });
    }
  